﻿let quickCalculationForm, advancedCalculationForm, fuelCostMessageContainer;
const errorClass = 'input-validation-error';

function addToFleet(event) {
    event.preventDefault();
    fuelCostMessageContainer.empty();
    const fuelTypesElement = advancedCalculationForm.find('#FuelTypes');
    const mileageElement = advancedCalculationForm.find('#Mileage');
    const manufacturerElement = advancedCalculationForm.find('#ManufacturerId');
    const modelGroupElement = advancedCalculationForm.find('#ModelGroupId');
    const derivativeElement = advancedCalculationForm.find('#DerivativeId');
    const quantityElement = advancedCalculationForm.find('#Quantity');

    const messages = [];
    if (!checkFuelType(fuelTypesElement)) {
        messages.push('Please select a fuel type');
    }
    if (!checkMileage(mileageElement)) {
        messages.push('Please select a valid mileage');
    }
    if (!checkManufacturer(manufacturerElement)) {
        messages.push('Please select a manufacturer');
    }
    if (!checkModel(modelGroupElement)) {
        messages.push('Please select a model');
    }
    if (!checkDerivative(derivativeElement)) {
        messages.push('Please select a derivative');
    }
    if (!checkQuantity(quantityElement)) {
        messages.push('Please select a valid quantity');
    }
    if (messages.length) {
        const ul = $('<ul>').addClass('list-unstyled field-validation-error margin-bottom-0');
        for (let i = 0; i < messages.length; i++) {
            ul.append($('<li>').append(messages[i]));
        }
        fuelCostMessageContainer.append(ul);
        return;
    }
    submitForms(event);
}

function checkFuelType(fuelType) {
    if (!fuelType.val()) {
        fuelType.addClass(errorClass);
        return false;
    }
    fuelType.removeClass(errorClass);
    return true;
}

function checkMileage(mileage) {
    const mileageVal = parseInt(mileage.val());
    if (isNaN(mileageVal) || mileageVal <= 0) {
        mileage.addClass(errorClass);
        return false;
    }
    mileage.removeClass(errorClass);
    return true;
}

function checkManufacturer(manufacturer) {
    if (!manufacturer.val()) {
        manufacturer.addClass(errorClass);
        return false;
    }
    manufacturer.removeClass(errorClass);
    return true;

}

function checkModel(model) {
    if (!model.val()) {
        model.addClass(errorClass);
        return false;
    }
    model.removeClass(errorClass);
    return true;

}

function checkDerivative(derivative) {
    if (!derivative.val()) {
        derivative.addClass(errorClass);
        return false;
    }
    derivative.removeClass(errorClass);
    return true;

}

function checkQuantity(quantity) {
    const quantityVal = parseInt(quantity.val());
    if (isNaN(quantityVal) || quantityVal <= 0) {
        quantity.addClass(errorClass);
        return false;
    }
    quantity.removeClass(errorClass);
    return true;
}

function quickCalculate(event) {
    if (!quickCalculationForm.valid())
        return;
    quickCalculationForm.find('#QuickExplicitlyCalculated').val('true');
    submitForms(event);
}

function advancedCalculate(event) {
    advancedCalculationForm.find('#ExplicitlyCalculated').val('true');
    submitForms(event);
}

function changeFuelTypes(event) {
    advancedCalculationForm.find("#ManufacturerId").val("");
    submitForms(event);
}

function changeManufacturer(event) {
    advancedCalculationForm.find("#ModelGroupId").val("");
    submitForms(event);
}

function submitForms(event) {
    event.preventDefault();
    const url = advancedCalculationForm.attr('action');

    let data = advancedCalculationForm.serializeArray();
    data = data.concat(quickCalculationForm.serializeArray());
    //console.log(data);
    postToUrl(url, data);
}

function removeFromFleet(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const row = button.parents("tr");
    row.remove();
    submitForms(event);
}

function postToUrl(path, params, method) {
    method = method || "post"; // Set method to post by default, if not specified.

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (let key in params) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", params[key].name);
        hiddenField.setAttribute("value", params[key].value);

        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
}

export function setupFuelCostCalculator() {
    if ($('[data-fuel-cost-calculator]').length) {
        quickCalculationForm = $("[data-quick-calculation]");
        advancedCalculationForm = $("[data-fuel-cost-form]");
        fuelCostMessageContainer = advancedCalculationForm.find('[data-fuel-cost-message-container]');

        advancedCalculationForm.on("change", "#FuelTypes", changeFuelTypes);

        advancedCalculationForm.on("change", "#ManufacturerId", changeManufacturer);

        advancedCalculationForm.on("change", "#ModelGroupId", submitForms);

        advancedCalculationForm.on("click", "[data-remove-from-fleet]", removeFromFleet);

        advancedCalculationForm.on("change", "#Area", submitForms);

        quickCalculationForm.on("change", "#QuickArea", submitForms);

        advancedCalculationForm.on("click", "[data-add-to-fleet]", addToFleet);

        advancedCalculationForm.on("click", "[data-advanced-calculate]", advancedCalculate);

        quickCalculationForm.on("click", "[data-quick-calculate]", quickCalculate);

    }
}

